// extracted by mini-css-extract-plugin
module.exports = {"root":"BlockHeader_root__2RGH3","iconWrap":"BlockHeader_iconWrap__1em3o","contentWrap":"BlockHeader_contentWrap__jxtZv","title":"BlockHeader_title__3vO28"};